<template>
  <div>
    <wc-data-box
      :loading='loading'
      :title='title'
      :titleIcon='titleIcon'
      :titleIconColor='titleIconColor'
      :showEdit='showEdit'
      @edit='openEdit'

    >
      <v-card-text>
        <span v-if='!value'>None...</span>
        <span v-html='value'></span>
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :title='title'
      :icon='titleIcon'
      :iconColor='titleIconColor'
      :showDialog='showDialog'
      :fullscreen='$vuetify.breakpoint.xs'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-textarea
        v-model='valueCopy'
        outlined
        auto-grow
        :hint='hint'
        persistent-hint
      ></v-textarea>
    </wc-dialog>

  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'single-value-box',
  props: {
    value: {
      required: true
    },
    title: {
      required: true,
      type: String
    },
    titleIcon: {
      required: false,
      type: String,
    },
    titleIconColor: {
      required: false,
      type: String,
    },
    hint: {
      required: false,
      type: String,
    },
    showEdit: {
      required: false,
      type: Boolean,
      default: true
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    valueCopy: {},
    showDialog: false
  }),
  methods: {
    openEdit () {
      this.valueCopy = _.cloneDeep(this.value)
      this.showDialog = true
    },
    save () {
      this.$emit('input', this.valueCopy)
      this.$emit('update')
      this.showDialog = false
    }
  }
}
</script>